import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Dropdown.scss';

const DropdownDivider = ({ className = '', ...props }) => {
  return (
    <hr
      {...props}
      className={classnames('dropdown-divider', styles.divider, className)}
    />
  );
};

DropdownDivider.propTypes = {
  style: PropTypes.shape({}),
  className: PropTypes.string,
};

export default DropdownDivider;
